import { render, staticRenderFns } from "./CashHeroNewClientChart.vue?vue&type=template&id=c01766da&scoped=true&"
import script from "./CashHeroNewClientChart.vue?vue&type=script&lang=js&"
export * from "./CashHeroNewClientChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01766da",
  null
  
)

export default component.exports